import { pickListingHighlights as e } from "./pickListingHighlights.mjs";
import { usePropertyAmenities as t } from "../propertyAmenities/usePropertyAmenities.mjs";
import { PROPERTY_AMENITY_CATEGORY_ORDER as n } from "@maat/api-main/types";
import { useMemo as r } from "react";
//#region src/properties/useListingAmenities.ts
var i = 2, a = 8, o = (e) => {
	let t = n.indexOf(e);
	return t === -1 ? n.length : t;
}, s = (e, t) => [...e].sort((e, n) => o(e.category) - o(n.category) || Number(t.has(n.slug)) - Number(t.has(e.slug))), c = (e) => n.map((t) => ({
	category: t,
	items: e.filter((e) => e.category === t)
})).filter((e) => e.items.length > 0), l = (t, n, r) => {
	let i = n, a = new Set([...t, ...i].map((e) => e.slug)), o = new Set((r ?? []).filter((e) => e.is_popular).map((e) => e.slug)), l = s(t, o), u = s(i, o), d = (r ?? []).filter((e) => e.category === "safety" && !a.has(e.slug)), f = new Set(t.map((e) => e.slug)), p = e(s([...t, ...i.filter((e) => !f.has(e.slug))], o), o);
	return {
		present: l,
		groups: c(l),
		facilities: u,
		facilityGroups: c(u),
		missingSafety: d,
		isCatalogueReady: !!r,
		highlights: p
	};
}, u = (e) => {
	let { data: n } = t(), i = e.unit.amenities, a = e.property.facilities;
	return r(() => l(i ?? [], a ?? [], n), [
		i,
		a,
		n
	]);
};
//#endregion
export { a as PREVIEW_AMENITIES, i as PREVIEW_MISSING_SAFETY, l as composeListingAmenities, u as useListingAmenities };
